export default "__VITE_ASSET__c97o$aE$__"